import React from "react";
import { SonicTermData } from "../../common/classes/SonicTerm";
import { dayOfWeekStr } from "../../utils/GeneralUtils";
import styles from "./EventItem.module.scss";
import { JikeiBadgeSVG } from "../../assets/img/JikeiBadgeSVG";
import SonicLink from "../../common/routing/SonicLink";

type Props = {
  id: string;
  name: string;
  img: string;
  start_date: Date;
  end_date?: Date;
  type: SonicTermData;
  tags: Array<string>;
  isJikei: boolean;
};

const EventItem: React.FC<Props> = (props) => {
  const { id, name, img, start_date, end_date, type, tags, isJikei } = props;

  return (
    <article className={styles["p-eventItem"]}>
      <div className={styles["p-eventItem__date"]}>
        <div className={styles["date-skewBox"]}>
          <div className={styles["date-skewBox__reset"]}>
            <div className={styles["p-eventItem__date-year"]}>
              {start_date.getFullYear()}
            </div>
            <div className={styles["p-eventItem__date-day"]}>
              <div>{`${
                start_date.getMonth() + 1
              }/${start_date.getDate()}(${dayOfWeekStr(start_date)})`}</div>
              {end_date && start_date < end_date ? (
                <div>{`- ${
                  end_date.getMonth() + 1
                }/${end_date.getDate()}(${dayOfWeekStr(end_date)})`}</div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <SonicLink to={`/event/${id}`}>
        <div className={styles["p-eventItem__wrapper"]}>
          <div className={styles["p-eventItem__top"]}>
            <img src={img} />
            {isJikei ? (
              <div className={styles["jikeiBadge"]}>
                <JikeiBadgeSVG />
              </div>
            ) : null}
          </div>
          <div className={styles["p-eventItem__content"]}>
            <div className={styles["p-eventItem__content-type"]}>
              <span className={styles["p-eventItem__content-type__skewBox"]}>
                {type.name}
              </span>
            </div>
            <div className={styles["p-eventItem__content-info"]}>
              <h2>{name}</h2>
            </div>
            <div className={styles["p-eventItem__content-tags"]}>
              {tags?.map((tag, i) => (
                <span key={i}>{`#${tag}`}</span>
              ))}
            </div>
          </div>
        </div>
      </SonicLink>
    </article>
  );
};

export default EventItem;
